import axios from "axios";
import { apiUrl } from "../config/environment";
import { getAuthHeaders } from "../utils/authUtils";

export type AdminUserLite = {
  _id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  companyName?: string;
  isAdmin?: boolean;
};

export type AdminUsersList = {
  total: number;
  page: number;
  limit: number;
  pages: number;
  items: AdminUserLite[];
};

export const searchUsers = async (q: string, page = 1, limit = 10) => {
  const { data } = await axios.get<AdminUsersList>(`${apiUrl}/api/users/admin`, {
    params: { q, page, limit },
    ...getAuthHeaders(),
  });
  return data;
};
